<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M7 7v32.5a1.5 1.5 0 003 0V33h13v6.5a1 1 0 002 0V18h5.5v2.11a5 5 0 00-3.31 2.39 1 1 0 00.36 1.36 1 1 0 001.37-.36 3 3 0 015.16 0 1 1 0 00.92.5.93.93 0 00.5-.14 1 1 0 00.36-1.36 5 5 0 00-3.31-2.39V18H38v21.5a1.5 1.5 0 003 0V7zm16 3v6H10v-6zm0 21H10v-5h13zm0-7H10v-6h13zm2-8v-6h13v6z"/><path d="M15 29.5h3a1 1 0 000-2h-3a1 1 0 000 2z"/></svg>